(() => {
  const SELECTOR = [
    'a.button:not(.button-unstyled):not(.dropdown-localization__button)',
    'button.button:not(.button-unstyled):not(.close-button):not(.dropdown-localization__button)',
    '.button-secondary:not(.button-unstyled)',
    'button.shopify-payment-button__button--unbranded',
    '.add-to-cart-button',
    '.category-browser__view-all',
    '[data-live-button-label]',
  ].join(', ');

  /**
   * @param {string} word
   */
  const titleCaseWord = (word) => {
    const letters = word.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, '');
    if (!letters) return word;
    const isAllCaps = letters === letters.toUpperCase();
    const isAllLower = letters === letters.toLowerCase();
    const isSimpleTitle =
      letters[0] === letters[0].toUpperCase() && letters.slice(1) === letters.slice(1).toLowerCase();
    if (!isAllCaps && !isAllLower && !isSimpleTitle) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };

  /**
   * @param {string} text
   */
  const toTitleCase = (text) =>
    text.replace(/[A-Za-zÀ-ÖØ-öø-ÿ]+(?:['’][A-Za-zÀ-ÖØ-öø-ÿ]+)*/g, titleCaseWord);

  /**
   * @param {ParentNode} root
   */
  const applyToRoot = (root) => {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) {
        const next = toTitleCase(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
  };

  const run = () => applyToRoot(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.(SELECTOR)) applyToRoot(node.parentNode || document);
        else if (node.querySelector?.(SELECTOR)) applyToRoot(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
